import { useEffect } from "react";
import { useRouter } from "next/router";
import { LandingPageRedirects } from "@config/clientRedirects";
import { ImgSrc } from "@config/image";
import LandingPages from "@config/landing-pages";
import theme from "@config/theme";
import { RedirectOrShow404 } from "@pages/404";

export type LandingPageProps = {
  name: string;
};

export const LandingPage = ({ name }: LandingPageProps) => {
  const router = useRouter();

  useEffect(() => {
    if (LandingPageRedirects[name]) {
      const url = new URL(window.location.href);
      url.pathname = LandingPageRedirects[name];
      router.replace(url);
    }
  }, [name, router]);

  if (LandingPageRedirects[name]) {
    return <></>;
  }

  const Content =
    LandingPages[name] ||
    (() => (
      <>
        Please add {name} to LandingPages <RedirectOrShow404 />
      </>
    ));

  return (
    <div className="landingPage">
      <Content />
      <style jsx>{`
        // container
        .landingPage {
          margin-bottom: 6rem;
        }

        // all container titles
        .landingPage :global(h2) {
          margin: 3rem 0 0;
          border-top: 0;
          padding-top: 0;
          font-size: ${theme.fonts.size.px24};
        }

        // all links
        .landingPage :global(.landingLink),
        .landingPage :global(.gridLinks a) {
          font-weight: 500;
          display: block;
        }

        // titles in grids use h4's
        .landingPage :global(h4) {
          font-size: ${theme.fonts.size.px18};
        }

        .landingPage :global(.gridLinks a) {
          margin: 0.5rem 0;
          background-image: url("${ImgSrc("/images/icons/arrow.svg")}");
          background-repeat: no-repeat;
          background-position: left center;
          padding-left: 2rem;
        }

        .landingPage :global(.gridLinks h4) {
          margin: 2.5rem 0 0;
        }

        :global(.three-column) {
          column-count: 3;
          column-gap: 1rem;
        }

        @media only screen and (max-width: ${theme.breakpoints.lg}px) {
          :global(.three-column) {
            column-count: 2;
          }
        }
        @media only screen and (max-width: ${theme.breakpoints.md}px) {
          :global(.three-column) {
            column-count: 1;
          }
        }

        :global(.landing-page-link-list) {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 1rem;
        }
        @media only screen and (max-width: ${theme.breakpoints.md}px) {
          :global(.landing-page-link-list) {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media only screen and (max-width: ${theme.breakpoints.sm}px) {
          :global(.landing-page-link-list) {
            grid-template-columns: repeat(1, 1fr);
          }
        }
        :global(.landing-page-link-list img) {
          margin: 3rem 0 1rem;
        }
        :global(.landing-page-link-list h4) {
          margin-top: 0;
        }

        .landingPage :global(hr) {
          display: block;
          height: 1px;
          border: 0;
          border-top: 1px solid ${theme.colors.gray4};
          margin: 3rem 0 0;
          padding: 0;
        }

        // padding for all grid containers
        :global(.landingPage .landingGridContainer) {
          padding-bottom: 1.5rem;
        }

        // mobile: remove all landing page containers left right padding
        @media only screen and (max-width: ${theme.breakpoints.sm}px) {
          :global(.landingPage .landingGridContainer) {
            padding: 0 !important;
          }
        }
      `}</style>
    </div>
  );
};

const FORCE_NAMED_EXPORT = {};
export default FORCE_NAMED_EXPORT;
